/* CSS */
import "/src/css/app.css";

// Alpine.js
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// Lazysizes
import 'lazysizes';